// styles.js
export const getStyles = (isRtl = false, isMobile = false) => {
  // base sizes
  const padding = isMobile ? '20px' : '40px';
  const formPadding = isMobile ? '18px' : '30px';
  const headerFont = isMobile ? '1.75rem' : '2.5rem';
  const headerMargin = isMobile ? '24px' : '40px';
  const gap = isMobile ? '16px' : '35px';

  return {
    requestQuote: {
      padding,
      maxWidth: isMobile ? '95%' : '85%',
      margin: '0 auto',
      textAlign: isRtl ? 'right' : 'left',
      direction: isRtl ? 'rtl' : 'ltr',
    },

    quoteHeader: {
      textAlign: 'center',
      marginBottom: headerMargin,
    },

    quoteHeaderH1: {
      color: 'rgb(154, 74, 32)',
      fontSize: headerFont,
      marginBottom: '16px',
    },

    quoteHeaderP: {
      color: '#666',
      fontSize: '1.05rem',
      maxWidth: '600px',
      margin: '0 auto',
    },

    quoteForm: {
      backgroundColor: '#f9f9f9',
      padding: formPadding,
      borderRadius: '10px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.06)',
    },

    // row: use for the flex rows that need to become column on mobile
    row: {
      display: 'flex',
      justifyContent: 'space-between',
      gap,
      marginBottom: '16px',
      flexDirection: isMobile ? 'column' : 'row',
      alignItems: 'stretch',
    },

    formGroup: {
      marginBottom: '16px',
      width: '100%',
      minWidth: 0,
    },

    label: {
      display: 'block',
      color: '#444',
      marginBottom: '8px',
      fontWeight: 500,
    },

    input: {
      width: '100%',
      padding: '10px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: '1rem',
      color: '#333',
      backgroundColor: 'white',
      transition: 'border-color 0.3s ease',
      boxSizing: 'border-box',
    },

    select: {
      width: '100%',
      padding: '10px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: '1rem',
      color: '#333',
      backgroundColor: 'white',
      transition: 'border-color 0.3s ease',
      boxSizing: 'border-box',
    },

    textarea: {
      width: '100%',
      padding: '10px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      fontSize: '1rem',
      color: '#333',
      backgroundColor: 'white',
      transition: 'border-color 0.3s ease',
      resize: 'vertical',
      minHeight: '100px',
      boxSizing: 'border-box',
    },

    checkboxGroup: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: isMobile ? '8px' : '12px',
    },

    checkboxItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      paddingRight: isRtl ? '0' : '4px',
    },

    submitButton: {
      backgroundColor: 'rgb(154, 74, 32)',
      color: 'white',
      padding: '12px 24px',
      border: 'none',
      borderRadius: '4px',
      fontSize: '1.05rem',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
      marginTop: '20px',
      width: isMobile ? '100%' : 'auto',
      display: 'inline-block',
    },

    // small helpers
    requiredMark: {
      color: 'red',
      marginRight: '6px',
    },
  };
};
